// What this build is, baked in at build time by scripts/deploy.sh (REACT_APP_GIT_SHA, REACT_APP_BUILD_TIME,
// REACT_APP_DEPLOY_ENV). The same values are written to /version.json by scripts/write-version.js after the build.
// Anything not set is "unknown". Exposed read-only as window.snookerVersion so it can be checked from the console.
export interface AppVersion {
    sha: string;
    builtAt: string;
    env: string;
}

const clean = (value: string | undefined) => (value ?? "").trim() || "unknown";

export const APP_VERSION: Readonly<AppVersion> = Object.freeze({
    sha: clean(process.env.REACT_APP_GIT_SHA),
    builtAt: clean(process.env.REACT_APP_BUILD_TIME),
    env: clean(process.env.REACT_APP_DEPLOY_ENV),
});

declare global {
    interface Window {
        snookerVersion?: Readonly<AppVersion>;
    }
}
